import React from "react";

export const TypeFormContext = React.createContext({
  typeFormScreen: "Смак та якість тютюну",
  setTypeFormScreen: () => {},
});
